import * as React from "react";
import { type ReactNode } from "react";
import classNames from "classnames";
import { Box, Stack } from "~/common/mui";

interface ToolbarProps {
  className?: string;
  left?: ReactNode;
  right?: ReactNode;
  noBottomSpace?: boolean;
}

const PageToolbar: React.FC<ToolbarProps> = (props) => {
  const { className, left, right, noBottomSpace } = props;

  return (
    <Box
      className={classNames(!noBottomSpace && "mb-30", className)}
      sx={{
        display: "flex",
        justifyContent: !left && right ? "flex-end" : "space-between",
      }}
    >
      {wrapMultipleChildren(left)}
      {wrapMultipleChildren(right)}
    </Box>
  );
};

const wrapMultipleChildren = (children: ReactNode) => {
  if (React.Children.count(children) > 1) {
    return <Stack gap={4} children={children} />;
  } else {
    return children;
  }
};

export default PageToolbar;
